const ERROR = {
  SYSTEM_ERROR: "System error. Please try again later!",
};
const PATH = {
  //  AUTH PATHS
  SIGNIN: "/",
  SIGNUP: "/signup",
  FORGETPASSWORD: "/signin/forget-password",
  OTPCODE: "/login/otp-code",
  PRIVACYPOLICY: "/privacy-policy",
  TERMSANDCONDITION: "/terms-and-conditions",
  DOCTOR_DASHBOARD: "/doctor/dashboard",
  DOCTOR_PRESCRIPTION_DASHBOARD: "/doctor/online-prescription-forms",
  DOCTOR_PRESCRIPTION_FORM: "/doctor/online-prescription-forms/:patientName",
  APPOINTMENT: "/doctor/appointment",
  TELE_CONSULTATION: "/doctor/appointment/tele-consultation",
  APPOINTMENT_NOTES: "/doctor/appointment/tele-consultation/notes",
  PATIENTS: "/doctor/patients",
  STAFF: "/doctor/staff",
  CHAT: "/doctor/chat",
  SLOTS: "/doctor/slots",
  NO_PAGE_FOUND: "*",
  PATIENTS_DETAILS: "/doctor/patients/:patientId/patient-details",
  APPOINTMENT_NOTES_DETAILS:
    "/doctor/patients/:patientId/patient-details/:appointmentId/appointment-notes",
  PROFILE: "/profile",
  STAFF_CHAT: "/doctor/staff/:staffId/chat",
  STAFF_SCREEN_CHAT: "/staff/chat",
  PROFILE_EDIT: "/profile/edit",
  PATIENT_DASHBOARD: "/patient/dashboard",
  PATIENT_OTPCODE: "/patient/login/otp-code",
  PATIENT_PRESCRIPTION: "/patient/prescriptions",
  PATIENT_PAYMENTDETAILS: "/patient/payment-details",
  PATIENT_APPOINTMENTDETAILS: "/patient/appointment",
  PATIENT_TELE_CONSULTATION: "/patient/appointment/tele-consultation",
  PATIENT_PROFILE: "/patient/profile",
  PATIENT_PRESCRIPTION_FORMS: "/patient/online-prescription-forms",
  DOCTOR_LIST: "/patient/doctor-list",
  DOCTOR_DETAILS: "/patient/slots",
  SUPERADMIN_PAYMENTDETAILS: "/superadmin/payment-details",
  SUPERADMIN_SETTINGS: "/superadmin/settings",
  COMPLETE_PROFILE: "/patient/complete-profile",
  PERSONAL_INFORMATION: "/patient/complete-profile/personal-info",
  SUPERADMIN_DASHBOARD: "/superadmin/dashboard",
  ADMIN_DASHBOARD: "/admin/dashboard",
  SUPERADMIN_USERMANAGEMENT: "/superadmin/user-management",
  ADMIN_USERMANAGEMENT: "/admin/user-management",
  ADMIN_PAYMENTDETAILS: "/admin/payment-details",
  ADMIN_SETTINGS: "/admin/settings",
  MEDICAL_HISTORY: "/patient/complete-profile/medical-history",
  PHARMACY: "/patient/complete-profile/pharmacy",
  ADMIN_DOCTORS: "/admin/doctors",
  SUPERADMIN_DOCTORS: "/superadmin/doctors",
  ADMIN_FEES: "/admin/fees",
  SUPERADMIN_FEES: "/superadmin/fees",
  SUPERADMIN_FORMS: "/superadmin/forms",
  ADMIN_FORMS: "/admin/forms",
  ADMIN_QUESTIONNAIRE: "/admin/forms/questionnaire",
  SUPERADMIN_QUESTIONNAIRE: "/superadmin/forms/questionnaire",
}; 

export { ERROR, PATH };
